export const emailRegex =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/

export const nameRegex = /^[a-zA-Z]+([- ]?[a-zA-Z]+)?$/

export const textRegex = /^[a-zA-Z][a-zA-Z.,!?()@#$%^`&*\\|/\s-]*$/
